export default defineNuxtLink({
    componentName: 'PrimeVueNuxtLink',
    trailingSlash: 'append'
});
